import React from 'react';
import { AreaChart, Area, XAxis, YAxis, Tooltip, ResponsiveContainer, ReferenceLine, CartesianGrid } from 'recharts';
import '../styles/TemperatureDashboard.css';

const TEMP_WARN = 42;
const TEMP_ALERT = 45;

const TemperatureDashboard = ({ series, bomba }) => {
  const showB1 = !bomba || bomba === 1;
  const showB2 = !bomba || bomba === 2;
  const titulo = bomba === 1 ? 'Temperatura — Bomba 1' : bomba === 2 ? 'Temperatura — Bomba 2' : 'Histórico de Temperatura';

  return (
    <div className="temp-card-body">
      <div className="temp-card-hdr">
        <div className="temp-card-title">
          <h2>{titulo}</h2>
          <span className="temp-tag">Últimas 24h</span>
        </div>
        <div className="temp-leg-row">
          {showB1 && <span className="temp-leg"><span className="temp-leg-line" style={{ background: '#2563eb' }}></span> Bomba 1</span>}
          {showB2 && <span className="temp-leg"><span className="temp-leg-line" style={{ background: '#d97706' }}></span> Bomba 2</span>}
          <span className="temp-leg"><span className="temp-leg-dash" style={{ borderColor: '#dc2626' }}></span> 45°C</span>
        </div>
      </div>

      <div className="temp-chart-container">
        <ResponsiveContainer width="100%" height="100%">
          <AreaChart data={series} margin={{ top: 8, right: 12, left: -16, bottom: 0 }}>
            <defs>
              <linearGradient id="b1grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#2563eb" stopOpacity={0.18} />
                <stop offset="100%" stopColor="#2563eb" stopOpacity={0} />
              </linearGradient>
              <linearGradient id="b2grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#d97706" stopOpacity="0.18" />
                <stop offset="100%" stopColor="#d97706" stopOpacity={0} />
              </linearGradient>
            </defs>
            <CartesianGrid stroke="var(--metric-line)" strokeDasharray="0" vertical={false} />
            <XAxis dataKey="t" tick={{ fontSize: 9, fill: 'var(--text-2)' }} stroke="var(--metric-line)" />
            <YAxis domain={[38, 52]} tick={{ fontSize: 9, fill: 'var(--text-2)' }} stroke="var(--metric-line)" tickFormatter={v => `${v}°C`} />
            <Tooltip contentStyle={{ background: 'var(--bg-1)', border: '1px solid var(--line)', fontSize: 11, color: '#fff' }} />
            <ReferenceLine y={TEMP_ALERT} stroke="#dc2626" strokeDasharray="6 4" />
            <ReferenceLine y={TEMP_WARN} stroke="#d97706" strokeDasharray="4 4" strokeOpacity={0.7} />
            {showB1 && <Area type="monotone" dataKey="b1" stroke="#2563eb" strokeWidth={2} fill="url(#b1grad)" isAnimationActive={false} />}
            {showB2 && <Area type="monotone" dataKey="b2" stroke="#d97706" strokeWidth={2} fill="url(#b2grad)" isAnimationActive={false} />}
          </AreaChart>
        </ResponsiveContainer>
      </div>

      <div className="temp-thr-row">
        <div className="temp-thr"><span className="temp-thr-l" style={{ borderColor: '#dc2626' }}></span> Alerta: 45°C</div>
        <div className="temp-thr"><span className="temp-thr-l" style={{ borderColor: '#d97706' }}></span> Advertencia: 42°C</div>
      </div>
    </div>
  );
};

export default TemperatureDashboard;